module.exports = "<span class=reportActions> <i ng-click=$ctrl.edit() class=material-icons> &#xE3C9; <md-tooltip>Editar</md-tooltip> </i> <i ng-click=$ctrl.delete($event) class=material-icons> &#xE872; <md-tooltip>Eliminar</md-tooltip> </i> </span> ";


//////////////////
// WEBPACK FOOTER
// ./src/components/tsz-company-actions/tsz-company-actions.html
// module id = 127
// module chunks = 1